import React, { FunctionComponent } from "react";
import styled from "styled-components";

import { LogoIcon } from "../logo";
import ExploreArtists from "../explore-artists";

interface SidebarFooterProps {
  className?: string;
  noExploreLink?: boolean;
}

const Footer: FunctionComponent<SidebarFooterProps> = ({
  className,
  noExploreLink,
}) => {
  return (
    <div className={className || ""}>
      <PoweredWrapper>
        <p className="powered-text">Powered by</p>
        <LogoIcon className="logo" />
      </PoweredWrapper>
      {!noExploreLink && <ExploreArtists />}
    </div>
  );
};

export const SidebarFooter = styled(Footer)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`;

const PoweredWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.tablet}px`}) {
    flex-direction: row;
    align-items: center;
    gap: 15px;
  }

  p {
    font-weight: 400;
    font-size: 10px;
    line-height: 14px;
    color: ${({ theme }) => theme.colors.icon};
    margin: 0;
  }

  .logo {
    fill: ${({ theme }) => theme.colors.icon};
    * {
      fill: ${({ theme }) => theme.colors.icon};
    }
  }
`;
